export default __webpack_public_path__ + "static/media/julie.00733edf.jpg";